// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"69b29e4925ee113b91b2","691":"2e26c2d5ab7cc105cce1"}[chunkId] + ".js";
};